import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from '@material-ui/core'
import { Form, Formik } from 'formik'
import { alterarStatus } from 'src/modules/locais/hooks/locaisRepository'
import { AlterarStatusData } from 'src/modules/locais/types'
import snackbarStore from 'src/stores/snackbar'
import SelectInput from '../Formik/Forms/SelectInput'
import locaisStore from 'src/modules/locais/store/locaisStore'

interface LocaisDialogProps {
  open: boolean
  handleClose: () => void
  primaryAction?: () => void
  status: string
  optionsStatus: string[]
  id: string
}

const initialValues: AlterarStatusData = {
  newStatus: ''
}

function LocaisDialog({
  open,
  handleClose,
  primaryAction,
  status,
  optionsStatus,
  id
}: LocaisDialogProps) {
  const handlePrimaryAction = () => {
    handleClose()
    primaryAction && primaryAction()
  }

  const options = optionsStatus.map((value: string) => {
    return { label: value, value }
  })

  const handleSubmit = async (data: AlterarStatusData) => {
    const res = await alterarStatus(id, data)
    if (res.ok) {
      snackbarStore.setMessage('Status alterado com sucesso!')
      locaisStore.locais.populate()
    } else {
      snackbarStore.setMessage(
        res.data?.message ?? 'Error ao alterar status do lote'
      )
    }
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="alert-dialog-title">Editar Status</DialogTitle>
      <DialogContent>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ handleSubmit, isSubmitting, values }) => (
            <Form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <SelectInput
                    name="newStatus"
                    label="Selecionar Status"
                    options={options}
                  />
                </Grid>
              </Grid>
              <Grid container justifyContent="flex-end">
                <DialogActions>
                  <Button onClick={handleClose} color="default" autoFocus>
                    Voltar
                  </Button>
                  <Button
                    onClick={handlePrimaryAction}
                    disabled={!!!values.newStatus || isSubmitting}
                    color="primary"
                    type="submit"
                    autoFocus
                  >
                    Confirmar
                  </Button>
                </DialogActions>
              </Grid>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}

export default LocaisDialog
